import { createContext, useContext, useState, useCallback } from 'react';

const ConfirmationContext = createContext();

export function ConfirmationProvider({ children }) {
  const [dialog, setDialog] = useState(null);

  const confirm = useCallback((message, options = {}) => {
    return new Promise((resolve) => {
      setDialog({
        message,
        onConfirm: () => {
          setDialog(null);
          resolve(true);
        },
        onCancel: () => {
          setDialog(null);
          resolve(false);
        },
        confirmText: options.confirmText || 'Confirmar',
        cancelText: options.cancelText || 'Cancelar',
        danger: options.danger || false,
      });
    });
  }, []);

  return (
    <ConfirmationContext.Provider value={{ confirm, dialog, setDialog }}>
      {children}
    </ConfirmationContext.Provider>
  );
}

export function useConfirmation() {
  const context = useContext(ConfirmationContext);
  if (!context) {
    throw new Error('useConfirmation deve ser usado dentro de ConfirmationProvider');
  }
  return context;
}
